<div id="auth" class="flex items-center mb-5 md:mb-0 bg-[#E5D9F2] flex-wrap lg:min-h-screen" >
    <div class="lg:w-1/2 w-full h-full  bg-white lg:min-h-screen" >
        <router-outlet />
    </div>
    <div class="lg:w-1/2 w-full flex justify-center items-center py-10 lg:py-0 bg-[#E5D9F2] lg:min-h-screen">
            <img src="Images/auth.png" alt="">
    </div>
</div>